module.exports = __webpack_public_path__ + "media/images/countrysquared/fi-a1363e0a18d9a61c5e5b4ff91d2acbc4.svg";